import React from "react";
import { PageBase } from "../../../Components/PageBase";
import "./Contraseña.css"
import img from "../../../icons/security.jpg"
//import { useRol } from "../../../Context";

function Contraseña() {

    // const password = ""

    // const { newPassword, setNewPassword } = useRol();
    // const [inputPassword, setInputPassword] = useState('');
    // const [newPassword, setNewPassword] = useState('');
    // const [confirmNewPassword, setConfirmNewPassword] = useState('');

    // const handleAddPassword = () => {
    //     if (inputPassword === password && newPassword === confirmNewPassword) {
    //         setNewPassword(newPassword);
    //         console.log('Se actualizo con exito tu contraseña!')
    //     } else {
    //         console.error('Error: Contraseña anterior incorrecta o confirmación no coincide');
    //     }
    //     setInputPassword('');
    //     setNewPassword('');
    //     setConfirmNewPassword('');
    // };

    // const handleInputChange = (event) => {
    //     setInputPassword(event.target.value);
    // };

    // const handleNewTitleChange = (event) => {
    //     setNewPassword(event.target.value);
    // };

    // const handleConfirmNewTitleChange = (event) => {
    //     setConfirmNewPassword(event.target.value);
    // };

    return (
        <>
            <PageBase />
            <div className="main-content">
                <div className="contraseña-container">
                    <div className="contraseña-porlet-card">
                        <div className="contraseña-form-container">
                            <h2>Cambio de contraseña</h2>
                            <p>Su contraseña no puede ser similar a su otra información personal. Debe contener al menos 8 caracteres y no puede ser enteramente numérica.</p>
                            <div className="form-data-contraseña">
                                <label>Contraseña antigua:</label>
                                <input
                                    type="password"
                                    placeholder="Contraseña actual"
                                // value={inputPassword}
                                // onChange={handleInputChange}
                                />
                            </div>
                            <div className="form-data-contraseña">
                                <label>Contraseña nueva:</label>
                                <input
                                    type="password"
                                    placeholder="Nueva contraseña"
                                // value={newPassword}
                                // onChange={handleNewTitleChange}
                                />
                            </div>
                            <div className="form-data-contraseña">
                                <label>Confirmación de contraseña nueva:</label>
                                <input
                                    type="password"
                                    placeholder="Confirmar nueva contraseña"
                                // value={confirmNewPassword}
                                // onChange={handleConfirmNewTitleChange}
                                />
                            </div>
                            <div className="form-data-contraseña">
                                <button>Cambiar contraseña</button>
                                {/* <button onClick={handleAddPassword}>Cambiar contraseña</button> */}
                            </div>
                        </div>
                        <div className="contraseña-img-container">
                            <img src={img} alt="security" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="contraseña-movil">
                <div className="container-main-movil">
                    <div className="card-password-movil">
                        <div className="contenido-password-movil">
                            <div className="contenido-password-title-movil">
                                <label>Cambio de contraseña</label>
                            </div>
                            <p>Su contraseña no puede ser similar a su otra información personal. Debe contener al menos 8 caracteres y no puede ser enteramente numérica.</p>
                            <div className="contenido-password-item-data-movil">
                                <label>Contraseña antigua:</label>
                                <input />
                            </div>
                            <div className="contenido-password-item-data-movil">
                                <label>Contraseña nueva:</label>
                                <input />
                            </div>
                            <div className="contenido-password-item-data-movil">
                                <label>Confirmacion de contraseña antigua:</label>
                                <input />
                            </div>
                            <div className="contenido-password-item-data-movil">
                                <button>Cambiar contraseña</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}

export { Contraseña }